<template>
    <div class="col-12 col-lg-8" v-if="finishedLoading">
        <!-- DADOS FINCANCEIROS -->
        <section>
            <div class="tit">
                <div class="float-left">
                    <h3>
                        Dados financeiros
                    </h3>
                </div>
                <div class="rating float-right">
                    <strong>
                        Score da operação
                        <span class="circle score"></span>
                        {{score}}
                    </strong>
                </div>
                <div class="clearfix"></div>
            </div>
            <!-- BOXES DE DADOS FINACEIROS -->
            <div class="row">
                <div class="col-12 col-lg-6 col-xl-4">
                    <div class="box">
                        <label>
                            Valor Solicitado
                        </label>
                        <p>
                            R$ {{valor}}
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-xl-4">
                    <div class="box">
                        <label>
                            Duração
                        </label>
                        <p>
                            {{prazo}} meses
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-12 col-xl-4">
                    <div class="box">
                        <label>
                            Valor total do empréstimo
                        </label>
                        <p>
                            R$ {{valorTotal}}
                        </p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6 col-xl-4">
                    <div class="box">
                        <label>
                            Valor da parcela
                        </label>
                        <p>
                            R$ {{parcela}}
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-xl-4">
                    <div class="box">
                        <label>
                            Juros
                        </label>
                        <p>
                            {{taxaJuros}}% a.m.
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-12 col-xl-4">
                    <div class="box">
                        <label>
                            Taxa total efetiva
                        </label>
                        <p>
                            R$ {{taxaTotal}}% a.a.
                        </p>
                    </div>
                </div>
            </div>
            <!-- ::::::::::: -->
        </section>
        <!-- :::::::: -->

        <!-- RECURSOS -->
        <section>
            <!-- SECTION TITLE -->
            <h3>
                Captação de recursos (investidores)
            </h3>
            <!-- ::::::: -->
            <!-- SECTION CONTENT -->
            <div class="row">
                <div class="col-12">
                    <div class="box no-color">
                        <label>
                            Inicio/Término
                        </label>
                        <p>
                            {{dataInicio}} - {{dataFim}}
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="box no-color">
                        <label>
                            Total de Investidores
                        </label>
                        <p>
                            {{investidores}}
                        </p>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="box no-color">
                        <label>
                            Valor total captado
                        </label>
                        <p>
                            R$ {{valorCaptado}}
                            <span class="percent">
                                {{percentValorCaptado}}%
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <!-- :::::::: -->
        </section>
        <!-- ::::: -->

        <!-- DADOS DA EMPRESA -->
        <section>
            <div class="tit">
                <div class="float-left">
                    <h3>
                        Dados da Empresa
                    </h3>
                </div>
                <div class="float-right">
                    <!-- <a href="#" class="edit-link">
                        editar informações
                    </a> -->
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <label>Empresa
                        <span>(Razão social)</span>
                    </label>
                    <span>{{razaoSocial}}</span>
                </div>
                <div class="col-12 col-lg-3">
                    <label>CPF/CNPJ</label>
                    <span>{{formattedCnpj}}</span>
                </div>
                <div class="col-12 col-lg-3">
                    <label>Nome do responsável</label>
                    <span>{{nomeResponsavel}}</span>
                </div>
                <div class="col-12 col-lg-6">
                    <label>Nome fantasia</label>
                    <span>{{razaoSocial}}</span>
                </div>
                <div class="col-12 col-lg-6">
                    <label>Telefone comercial</label>
                    <span>{{telefone}}</span>
                </div>
                <div class="col-12">
                    <label>Endereço</label>
                    <span>{{Endereco}}</span>
                </div>
                <div class="col-12 col-lg-6 col-xr-4">
                    <label>Site</label>
                    <span>{{site}}</span>
                </div>
                <div class="col-12 col-lg-6 col-xl-4">
                    <label>
                        Email
                    </label>
                    <span>
                        {{email}}
                    </span>
                </div>
                <div class="col-12 col-lg-12 col-xr-4">
                    <label>Redes Sociais</label>
                    <span class="social-links">
                        <a v-if="facebook" :href="facebook" class="fab fa-facebook-square" target="_blank"></a>
                        <a v-if="twitter" :href="twitter" class="fab fa-twitter" target="_blank"></a>
                        <a v-if="linkdin" :href="linkdin" class="fab fa-linkedin-in" target="_blank"></a>
                        <a v-if="instagram" :href="instagram" class="fab fa-instagram" target="_blank"></a>
                        <a v-if="vimeo" :href="vimeo" class="fab fa-vimeo-v" target="_blank"></a>
                    </span>
                </div>
            </div>
        </section>
        <!-- ::::::::: -->

        <!-- SOBRE -->
        <section>
            <h4>
                Sobre a empresa
            </h4>
            <div v-html="sobreEmpresa"></div>
        </section>
        <!-- :::::::: -->

        <!-- DOCUMENTO -->
        <section>
            <h3>
                Documentos
            </h3>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <a :href="lpUrl+'/termos-e-condicoes/'" class="docs">
                        Termos e Condições
                    </a>
                </div>
                <div class="col-12 col-lg-6">
                    <a :href="lpUrl+'/politica-de-privacidade/'" class="docs">
                        Politica de Privacidade
                    </a>
                </div>
            </div>
        </section>
        <!-- ::::::::::: -->
    </div>
</template>

<script>
    import ApiClient from '../../utils/api-client'
    import * as mutationTypes from '@/store/mutation-types.js'
    import Masker from '@/utils/masker'

    export default {
        data() {
            return {
                lpUrl:process.env.LP_URL,
                finishedLoading: false,
                solicitacao: null,
            }
        },
        props: ['id'],
        computed: {
            getId() {
                return this.id
            },
            formattedCnpj: function () {
                return Masker.maskCnpj(this.solicitacao.Documento)
            },
            razaoSocial: function () {
                return this.solicitacao.Ccb.RazaoSocial
            },
            nomeFantasia: function () {
                return this.solicitacao.Ccb.NomeFantasia
            },
            nomeResponsavel: function () {
                return this.solicitacao.Nome
            },
            telefone: function () {
                return this.solicitacao.TelefoneComercial
            },
            sobreEmpresa: function () {
                return this.solicitacao.Ccb.DescricaoEmpresa
            },
            scoreClass: function () {
                if (!this.solicitacao.Score) return ""
                return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase()
            },
            score: function () {
                return this.solicitacao.Score
            },
            valor: function () {
                if (!this.solicitacao) return null
                return this.formatCurrency(this.solicitacao.Valor)
            },
            prazo: function () {
                return this.solicitacao.Prazo
            },
            parcela: function () {
                return this.formatCurrency(this.solicitacao.ValorParcela)
            },
            valorTotal: function () {
                if (this.solicitacao.ValorParcela == 0) {
                    return this.formatCurrency(this.solicitacao.Valor)
                } else {
                    return this.formatCurrency(this.solicitacao.ValorParcela * this.solicitacao.Prazo)
                }
            },
            taxaJuros: function () {
                return this.formatCurrency(this.solicitacao.TaxaJuros);
            },
            taxaTotal: function () {
                return this.formatCurrency(this.solicitacao.RetornoBrutoAnual)
            },
            dataInicio: function () {
                return this.formatData(this.solicitacao.InicioCaptacao)
            },
            dataFim: function () {
                return this.formatData(this.solicitacao.FimCaptacao)
            },
            dataFuncadao: function () {
                return this.formatData(this.solicitacao.Ccb.DataFundacao)
            },
            numeroEmpregados: function () {
                return this.solicitacao.Ccb.QuantidadeEmpregados
            },
            grupoEconomico: function () {
                return this.hasGroup(this.solicitacao.Ccb.NomeGrupoEconomico)
            },
            Endereco: function () {
                return this.formatAdress(this.solicitacao.Ccb.Endereco)
            },
            site: function () {
                return this.solicitacao.Ccb.RedesSociais.Site
            },
            facebook: function () {
                return this.solicitacao.Ccb.RedesSociais.Facebook
            },
            twitter: function () {
                return this.solicitacao.Ccb.RedesSociais.Twitter
            },
            instagram: function () {
                return this.solicitacao.Ccb.RedesSociais.Instagram
            },
            linkdin: function () {
                return this.solicitacao.Ccb.RedesSociais.Linkedin
            },
            vimeo: function () {
                return this.solicitacao.Ccb.RedesSociais.Vimeo
            },
            email: function () {
                return this.solicitacao.Email
            },
            valorCaptado: function () {
                return this.formatCurrency(this.solicitacao.ValorCaptado)
            },
            investidores: function () {
                return this.solicitacao.QuantidadeReservasInvestimento
            },
            percentValorCaptado: function () {
                if (this.solicitacao.ValorCaptado === 0 || this.solicitacao.ValorCaptado === undefined) {
                    return this.formatCurrency(0);
                } else {
                    return this.formatCurrency(this.solicitacao.ValorCaptado * 100 / this.solicitacao.Valor);
                }
            }
        },
        methods: {
            ajustIdOportunidade(id, qtd) {
                var s = String(id);
                while (s.length < (qtd || 2)) {
                    s = "0" + s;
                }
                return s;
            },
            formatCurrency(value) {
                if (value !== undefined) {
                    return value.toLocaleString('pt-BR', {
                        minimumFractionDigits: "2",
                        maximumFractionDigits: 2
                    })
                }
            },
            formatData(data) {
                var date = new Date(data);
                return date.toLocaleDateString('pt-BR');
            },
            hasGroup(item) {
                let msg

                if (item) {
                    msg = "Pertence a um grupo econômico";
                } else {
                    msg = "Não pertence a nenhum grupo econômico";
                }

                return msg
            },
            formatAdress(obj) {

                let logra = obj.Logradouro;
                let num = obj.Numero;
                let comp = obj.Complemento;
                let bairro = obj.Bairro;
                let cep = obj.Cep;
                let city = obj.Cidade;
                let uf = obj.Uf;

                let adress = logra + ", " + num + " - " + comp + ", " + bairro + " - " + cep + ", " + city + "/" + uf

                return adress
            }
        },
        created() {

            this.$store.commit(mutationTypes.START_LOADING)

            ApiClient.getLoanRequest(this.getId)
                .then(response => {
                    this.solicitacao = response;

                    this.finishedLoading = true
                    this.$store.commit(mutationTypes.STOP_LOADING)
                })
                .catch(() => {
                    this.finishedLoading = true
                    this.$store.commit(mutationTypes.STOP_LOADING)
                });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/loansProfiles/DetalhesCcb.vue